// extracted by mini-css-extract-plugin
export default {"productGrid":"aZ-z","centerLink":"bZ-z","productSection":"cZ-z","item":"dZ-z","ctaButton":"eZ-z"};